<template>

		<BaseAccount :title="$t('Account Settings')">

    <div class="appointment_account_settings px-1" v-if="isLoaded">
      <div class="flex flex-wrap ">
        <div class="w-full">
          <div class="login_from mt_32">
            <div class="sr-only">{{ $t('Personal Data') }}</div>
            
            <div class="pb-[2.4rem] p-0">
              <InputField
                v-model="account.name"
                :label="$t('Name *')"
                required
                ref="nameField"
                inputClass="input mt-4"
                :inputProps="{ autocomplete: 'given-name' }"
                :errorMessage="formErrors.name"
                @input="() => clearFieldError('name')"
                @blur="() => validateField('name')"
              />
            </div>
            <div class="pb-[2.4rem] p-0">
              <InputField
                v-model="account.surname"
                :label="$t('Last Name')"
                inputClass="input mt-4"
                :inputProps="{ autocomplete: 'family-name' }"
                @input="() => clearFieldError('surname')"
              />
            </div>
            <div class="pb-[2.4rem] p-0">
              <label class="text-black font-bold">
                {{$t('Contact information *')}}
              </label>
              <div class="flex flex-nowrap gap-[0_1rem]">
                <CountryCode/>
                <InputField class="w-full"
                  v-model="account.phone"
                  required
                  ref="phoneField"
                  inputClass="input mt-4"
                  inputType="tel"
                  :onlyDigits="true"
                  :inputProps="{ inputmode: 'numeric', pattern: '\\d*', maxlength: 15, autocomplete: 'tel' }"
                  :errorMessage="formErrors.phone"
                  @input="() => clearFieldError('phone')"
                  @blur="() => validateField('phone')"
                />
              </div>
            </div>
            <div class="pb-[2.4rem] p-0">
              <div :class="emailEditable ? 'bg-white-50 rounded-[1.6rem] border border-dashed border-black/20 px-3 py-2' : ''">
                <InputField
                  v-model="account.email"
                  :label="$t('Email')"
                  inputClass="input mt-4"
                  :infoInInput="emailEditable ? $t('Cancel') : $t('Modify')"
                  inputType="email"
                  :customInputClass="emailEditable ? '' : 'opacity-60 cursor-not-allowed bg-gray-100 text-gray-500'"
                  :inputProps="{ autocomplete: 'email', disabled: !emailEditable }"
                  :errorMessage="formErrors.email"
                  ref="emailField"
                  @input="onEmailInput"
                  @blur="() => validateField('email')"
                  @info-click="toggleEmailEditing"
                />
              </div>
            </div>

            <div class="sr-only">{{ $t('Address') }}</div>
            
            <div class="pb-[2.4rem] p-0">
              <InputField
                v-model="account.addressLine1"
                :label="$t('Address')"
                inputClass="input mt-4"
                :inputProps="{ autocomplete: 'address-line1' }"
              />
            </div>
            <div class="flex flex-wrap -mx-2">
              <div class="w-1/2 px-2 pb-[2.4rem] p-0">
                <InputField
                  v-model="account.postalCode"
                  :label="$t('Postal Code')"
                  inputClass="input mt-4"
                  :inputProps="{ autocomplete: 'postal-code', maxlength: 10 }"
                />
              </div>
              <div class="w-1/2 px-2 pb-[2.4rem] p-0">
                <InputField
                  v-model="account.city"
                  :label="$t('City')"
                  inputClass="input mt-4"
                  :inputProps="{ autocomplete: 'address-level2' }"
                />
              </div>
            </div>
             <div class="flex flex-wrap -mx-2">
              <div class="w-1/2 px-2 pb-[2.4rem] p-0">
                <InputField
                  v-model="account.town"
                  :label="$t('Town')"
                  inputClass="input mt-4"
                  :inputProps="{ autocomplete: 'address-level3' }"
                />
              </div>
              <div class="w-1/2 px-2 pb-[2.4rem] p-0">
                <InputField
                  v-model="account.country"
                  :label="$t('Country')"
                  inputClass="input mt-4"
                  :inputProps="{ autocomplete: 'country-name' }"
                />
              </div>
            </div>

            <div class="pb-[2.4rem] p-0">
              <InputField
                v-model="account.dni"
                :label="$t('DNI')"
                inputClass="input mt-4"
                :inputProps="{ maxlength: 20, autocomplete: 'off' }"
              />
            </div>

            <CustomButton
              :label="$t('Save')"
              @click="saveChanges"
            />
          </div>
        </div>
      </div>
    </div>

    <ToastMessage
      :message="toast.message"
      :visible="toast.visible"
      :type="toast.type"
      @close="handleToastClose"
    />
  </BaseAccount>

</template>

<script>
import accountSettingsConfig from './AccountSettingsView.logic';

export default accountSettingsConfig;
</script>

